import SummarizedClient from '../../models/client/summarizedClient.model';

const UNAPPROVED_REGISTRATION_DATE = '30/12/1899';

const isClientApprovedForOrder = (
  client: SummarizedClient | null | undefined,
  requiresApproval: boolean
): boolean => {
  if (!requiresApproval) {
    return true;
  }

  if (!client?.id || typeof client.aprovacaoCadastro !== 'string') {
    return false;
  }

  const approvalDate = client.aprovacaoCadastro.trim();

  return (
    approvalDate.length > 0 && approvalDate !== UNAPPROVED_REGISTRATION_DATE
  );
};

export default isClientApprovedForOrder;
